

export default function Text(props) {

		let {data} = props

		//make 12 if no data default to xs. if no xs then it will be 12
		let xs = data && data.xs ? data.xs : '12'
		let sm = data && data.sm ? data.sm : xs
		let md = data && data.md ? data.md : sm
		let lg = data && data.lg ? data.lg : md

		let className= 'col-xs-'+ xs + ' col-sm-'+ sm + ' col-md-'+ md + ' col-lg-'+ lg
		return(
				<div id={data.richId} className={className} style={{padding: '0px 10px', display: 'flex', flexDirection: 'column', justifyContent: 'center'}} >
						{ data.header ? <div><h2>{data.header}</h2></div> : <div style={{paddingTop: '10px'}} /> }
						<span className='textModule-body'>{data.body}</span>
				</div>
    )


}



// WEBPACK FOOTER //
// ./components/contentTypes/text/text.js